import { useHistory } from 'react-router-dom'
import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    const history = useHistory()
    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/abdomen/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/abdomen/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/abdomen/linhasReferencia"
        },
        {
            text: "Reformatações Multiplanares",
            url: "/abdomen/reformatacoesMultiplanares"
        },
        {
            text: "Protocolos de Pós-processamento",
            url: "/abdomen/reformatacoes"
        },
        {
            text: "Back-up",
            url: "/abdomen/reformatacoes/backup"
        },
        {
            text: "Documentação",
            url: "/abdomen/reformatacoes/documentacao"
        }
    ]
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice Abdômen Total com Contraste I.V.</Title>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}